export default __webpack_public_path__ + "static/media/bootcamp-3.6bc1dc13.svg";